import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import {
  GetUploadHistoriesResponse,
  getUploadHistory,
} from '@apis/productBulk/upload';

export const useUploadDetail = (uploadId: number) => {
  const queryOptions: UseQueryOptions<
    PageResponse<GetUploadHistoriesResponse>,
    Error
  > = {
    queryKey: ['productUploadDetail', uploadId],
    queryFn: () => {
      return getUploadHistory(uploadId);
    },
  };
  return useQuery(queryOptions);
};
